import { HStack, Button, useColorModeValue, Icon } from '@chakra-ui/react';
import { GripVertical, Grid3x3 } from 'lucide-react';

export type ViewMode = 'compact' | 'comfortable';

interface ViewToggleProps {
  value: ViewMode;
  onChange: (value: ViewMode) => void;
}

/**
 * View Toggle Component
 * Toggles between "Compact" (table) and "Comfortable" (card) views
 */
export function ViewToggle({ value, onChange }: ViewToggleProps) {
  const activeBg = useColorModeValue('blue.500', 'blue.600');
  const activeColor = 'white';
  const inactiveColor = useColorModeValue('gray.600', 'gray.400');
  const inactiveBg = useColorModeValue('gray.100', 'gray.700');
  const hoverBg = useColorModeValue('gray.200', 'gray.600');

  return (
    <HStack spacing={0} bg={inactiveBg} rounded="md" p={1}>
      <Button
        leftIcon={<Icon as={GripVertical} w={4} h={4} />}
        size="sm"
        variant={value === 'compact' ? 'solid' : 'ghost'}
        colorScheme={value === 'compact' ? 'blue' : undefined}
        bg={value === 'compact' ? activeBg : 'transparent'}
        color={value === 'compact' ? activeColor : inactiveColor}
        onClick={() => onChange('compact')}
        _hover={{
          bg: value === 'compact' ? activeBg : hoverBg,
        }}
        fontWeight="medium"
        borderRadius="md"
      >
        Compact
      </Button>
      <Button
        leftIcon={<Icon as={Grid3x3} w={4} h={4} />}
        size="sm"
        variant={value === 'comfortable' ? 'solid' : 'ghost'}
        colorScheme={value === 'comfortable' ? 'blue' : undefined}
        bg={value === 'comfortable' ? activeBg : 'transparent'}
        color={value === 'comfortable' ? activeColor : inactiveColor}
        onClick={() => onChange('comfortable')}
        _hover={{
          bg: value === 'comfortable' ? activeBg : hoverBg,
        }}
        fontWeight="medium"
        borderRadius="md"
      >
        Comfortable
      </Button>
    </HStack>
  );
}
